import { Link } from "@mui/material";
import { TbShirtSport } from "react-icons/tb";
import { HiOutlineTicket } from "react-icons/hi";
import { MdOutlineEventSeat, MdOutlinedFlag } from "react-icons/md";

export const OKCCometsLink = () => (
  <Link
    target="_blank"
    href="https://am.ticketmaster.com/spurs/"
    sx={{
      fontWeight: 500,
      color: "primary.main",
      textDecoration: "none",
    }}
  >
    Account Manager
  </Link>
);

export const purchaseSeatsLanguages = {
  similarSeatModalBody: (seatTitle: string) => {
    return <>We are going to find similar seats for all games in your pack.</>;
  },
  progressBarText:
    "Add 2 games and get 10% off, add 4 games and get 20% off, add 6 games and get 30% off including an OKC Comets hat or add 10 games to include an on field batting practice experience!",
};

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Choose Your Games",
    description: "Select the games you wish to attend.",
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Login to Account Manager",
    description:
      "Connect to your Oklahoma City Comets account using our secure Ticketmaster login.",
  },
  {
    icon: <TbShirtSport />,
    title: "Select Your Seats",
    description: "Select the seats you wish to purchase for each game.",
  },
  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description: (
      <>
        Tickets will be available in your Oklahoma City Comets <OKCCometsLink />{" "}
        in early February 2025. Reach out to Live Fan Support for any questions.
      </>
    ),
  },
];

export const faqs = [
  {
    title: "How does the Comets Flex Plan work?",
    description: (
      <>
        The Comets Flex Plan allows fans to select any seat to select games
        hosted by Comets Flex Plan. Simply log into your Comets Flex Plan{" "}
        <OKCCometsLink /> and select games.
      </>
    ),
  },
  {
    title: "Do I have to select all my games now?",
    description: "Yes, you must select all games at the time of purchase.",
  },
  {
    title: "Can I choose seats throughout the venue?",
    description: "Yes, you can choose from all current available inventory.",
  },
  {
    title: "Where are event tickets delivered?",
    description: (
      <>
        Tickets will be delivered directly within your Comets Flex Plan{" "}
        <OKCCometsLink /> in early February, 2025.
      </>
    ),
  },
];
